import useAlertQuery from "@/query/alert-query";
import { cn } from "@/utils/cn";
import { useEffect, useState } from "react";

const getAlertImageSrc = (type?: string | null) => {
  switch (type) {
    case "Онц ноцтой":
      return "/images/status/onts_notstoi.png";
    case "Анхааруулга":
      return "/images/status/anhaaruulga.png";
    default:
      return null;
  }
};

const AlertDialog: React.FC = () => {
  const { data: alertData, isLoading } = useAlertQuery();

  const getInitialTab = (data?: typeof alertData) =>
    data?.today_content ? "today" : "headline";

  const [tab, setTab] = useState<"today" | "headline">(() =>
    getInitialTab(alertData)
  );

  useEffect(() => {
    setTab(getInitialTab(alertData));
  }, [alertData]);

  const alertType =
    alertData?.[tab === "today" ? "today_type" : "headline_type"];
  const alertContent =
    alertData?.[tab === "today" ? "today_content" : "headline_content"];
  const alertImg = getAlertImageSrc(alertType);

  return (
    <div className="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2">
      <div className="relative overflow-hidden flex justify-center items-center">
        {alertImg && (
          <img
            className="absolute"
            src={alertImg}
            alt={alertType || "Анхааруулга"}
          />
        )}
        <div className="p-6 bg-black/60 rounded-xl shadow-xl text-white backdrop-blur-sm w-[700px] text-2xl">
          {!alertData && isLoading ? (
            <div>Түр хүлээнэ үү...</div>
          ) : (
            <>
              <div className="flex justify-between mb-5">
                {alertData?.today_content && (
                  <div
                    className={cn(
                      "flex-1 text-center cursor-pointer",
                      tab == "today" && "font-bold border-b pb-3"
                    )}
                    onClick={() => setTab("today")}
                  >
                    Өнөөдөр
                  </div>
                )}
                {alertData?.headline_content && (
                  <div
                    className={cn(
                      "flex-1 text-center cursor-pointer",
                      tab == "headline" && "font-bold border-b pb-3"
                    )}
                    onClick={() => setTab("headline")}
                  >
                    Онцлох мэдээ
                  </div>
                )}
              </div>
              <p className="p-10 text-center">{alertContent}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default AlertDialog;
